import { DsrApi } from "@/api";
import i18n from "@/i18n";
import router from "@/router";
import { showSuccessSnackbar, showErrorSnackbar } from "@/utilities/snackbar";
import { DownloadFile } from "@/utilities/fileManager.js";

export async function getSchema(type) {
  const { data } = await DsrApi.getSchema(type);
  return data;
}

export async function create(dsrToSave) {
  const { data } = await DsrApi.create(dsrToSave);
  return data;
}

export async function get(id) {
  const { data } = await DsrApi.get(id);
  return data;
}

export async function getByEnterpriseIdAndYear(enterpriseId, year) {
  let data;
  try {
    ({ data: data } = await DsrApi.getByEnterpriseIdAndYear(
      enterpriseId,
      year
    ));
  } catch (ex) {
    if (ex.response.status === 404) {
      router.push({ name: "users" });
    }
  }
  return data;
}

export async function getAllByEnterpriseId(enterpriseId) {
  const { data } = await DsrApi.getByEnterpriseIdAndYear(enterpriseId, null);
  return data;
}

export async function getSummariesByEnterpriseId(enterpriseId) {
  const { data } = await DsrApi.getSummariesByEnterpriseId(enterpriseId);
  return data;
}

export async function compare(ids, lang = "it") {
  const { data } = await DsrApi.compare(ids, lang);
  return data;
}

export async function exportComparison(
  ids,
  lang = "it",
  includeDetail = false
) {
  try {
    const { data, headers } = await DsrApi.exportComparison(
      ids,
      lang,
      includeDetail
    );
    DownloadFile.downloadBlobWithHeaders(data, headers, "dsr_confronto.xlsx");
  } catch (ex) {
    showErrorSnackbar(undefined, i18n.t("dsr.comparison.view.exportError"));
  }
}

export async function exportComparisonWord(
  ids,
  templateHash,
  isMicroEnterprise = false,
  lang = "it"
) {
  try {
    const { data, headers } = await DsrApi.exportComparisonWord(
      ids,
      templateHash,
      isMicroEnterprise,
      lang
    );
    DownloadFile.downloadBlobWithHeaders(data, headers, "dsr_confronto.docx");
  } catch (ex) {
    showErrorSnackbar(undefined, i18n.t("dsr.comparison.view.exportError"));
  }
}

/* export async function getBlobByHash(hash) {
  let { data } = await DsrApi.getBlobByHash(hash);
  data = JSON.parse(data, JsonUtils.infinityReviver);
  return data;
} */

export async function save(dsr) {
  await DsrApi.save(dsr);
  showSuccessSnackbar(200, i18n.t("dsr-saved-correctly"));
}

export async function remove(id) {
  await DsrApi.remove(id);
  showSuccessSnackbar(200, i18n.t("dsr-deleted-correctly"));
}

export async function rename(id, name) {
  await DsrApi.rename(id, name);
  showSuccessSnackbar(200, i18n.t("dsr-renamed-correctly"));
}

/* export async function createDsrObject(formData) {
  const { data } = await DsrApi.createDsrObject(formData);
  return data;
} */

export async function exportWord(
  dsrId,
  templateHash,
  isMicroEnterprise,
  lang = "it"
) {
  try {
    const result = await DsrApi.exportWord(
      dsrId,
      templateHash,
      isMicroEnterprise,
      lang
    );
    showSuccessSnackbar(200, i18n.t("dsr-exported-correctly"));
    return result;
  } catch (ex) {
    showErrorSnackbar(undefined, i18n.t("dsr-export-error"));
  }
}

export async function getFacilities(id) {
  const { data } = await DsrApi.getFacilities(id);
  return data;
}

export async function getTemplates(enterpriseId) {
  const { data } = await DsrApi.getTemplates(enterpriseId);
  return data.map((template) => ({
    ...template,
    confirmingDelete: false,
  }));
}

export async function deleteTemplate(id) {
  await DsrApi.deleteTemplate(id);
  showSuccessSnackbar(200, i18n.t("dsr-template-deleted-correctly"));
}

export async function uploadTemplate(enterpriseId, file) {
  try {
    const { data } = await DsrApi.uploadTemplate(enterpriseId, file);
    return data;
  } catch (ex) {
    showErrorSnackbar(undefined, ex.response?.data);
  }
}

export async function downloadSampleTemplate() {
  try {
    const { data, headers } = await DsrApi.downloadSampleTemplate();
    DownloadFile.downloadBlobWithHeaders(
      data,
      headers,
      "dsr_template_sample.docx"
    );
  } catch (ex) {
    showErrorSnackbar(undefined, "Errore durante il download del template DSR");
  }
}

export async function getCoordinates(address) {
  try {
    const { data } = await DsrApi.getCoordinates(address);
    return data;
  } catch (ex) {
    showErrorSnackbar(undefined, ex.response?.data);
  }
}

export async function getEmissionFactorCoefficients() {
  try {
    const { data } = await DsrApi.getEmissionFactorCoefficients();
    return data;
  } catch (ex) {
    showErrorSnackbar(undefined, ex.response?.data);
  }
}

export async function addFacilities(dsrId, facilitiesDto) {
  await DsrApi.addFacilities(dsrId, facilitiesDto);
  showSuccessSnackbar(200, i18n.t("dsr-facilities-added-correctly"));
}

export async function getEnterpriseExportLogs(enterpriseId) {
  try {
    const { data } = await DsrApi.getEnterpriseExportLogs(enterpriseId);
    return data;
  } catch (ex) {
    showErrorSnackbar(undefined, ex.response?.data);
  }
}
